import { createSelector } from 'redux-bundler'
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';

export default {
  name: 'plugins',

  getReducer(){
    const initialData = {
      loading: false,
      components: []
    }

    return (state = initialData, { type, payload }) => {

      if(type === 'PLUGINS_STARTED_LOADING'){
        return Object.assign({}, state, {
          loading: true
        })
      }

      if(type === 'PLUGINS_STOPPED_LOADING'){
        return Object.assign({}, state, {
          loading: false
        })
      }

      if(type === 'PLUGINS_ADDED_COMPONENTS'){
        return Object.assign({}, state, {
          components: state.components.concat(payload)
        })
      }

      return state;
    }
  },

  // ACTION CREATORS
  doAddPluginComponents: (components) => ({ dispatch }) => {
    dispatch({type:'PLUGINS_ADDED_COMPONENTS', payload: components});
  },

  doStartLoadingPlugins: () => ({ dispatch, store }) => {
    dispatch({type:'PLUGINS_STARTED_LOADING', payload:{notification:{
      title: 'Plugin Notification',
      message: 'Plugins Loading',
      level: 'info'
    }}});
  },

  doStopLoadingPlugins: () => ({ dispatch }) => {
    dispatch({type:'PLUGINS_STOPPED_LOADING', payload:{notification:{
      title: 'Plugin Notification',
      message: 'Plugins Loading Completed',
      level: 'info'
    }}});
  },

  // SELECTORS
  selectPluginsAreLoading: (state) => {
    return state.plugins.loading;
  },

  selectAllComponents: (state) => {
    return state.plugins.components;
  },

  selectComponentsLeftSidebarTop: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'left-sidebar-top'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsLeftSidebarBottom: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'left-sidebar-bottom'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsRightSidebarTop: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'right-sidebar-top'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsRightSidebarBottom: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'right-sidebar-bottom'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsBasicToolbar: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'basic-toolbar'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsLowerRight: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'lower-right-toolbar'}), ['sortOrder']),(c) => {return c.component});
    }
  ),

  selectComponentsUpperRight: createSelector(
    'selectAllComponents',
    (allComponents) => {
      return map(sortBy(filter(allComponents, {'region': 'upper-right-toolbar'}), ['sortOrder']),(c) => {return c.component});
    }
  )
}